import { Breakpoint } from '../types';
import { Theme, useMediaQuery } from '@mui/material';
import { useToggle } from './useToggle';
import { useEffect } from 'react';

export function useBreakpoint(): Breakpoint {
    const [isClient, setIsClient] = useToggle(false);
    useEffect(() => {
        setIsClient(true);
    }, [setIsClient]);

    const isCompact = useMediaQuery((theme: Theme) => theme.breakpoints.only('compact'), {
        defaultMatches: typeof window !== 'undefined' ? window.innerWidth < 600 : undefined
    });
    const isMedium = useMediaQuery((theme: Theme) => theme.breakpoints.only('medium'), {
        defaultMatches: typeof window !== 'undefined' ? window.innerWidth <= 840 : undefined
    });

    if (!isClient) return Breakpoint.Expanded;

    if (isCompact) {
        return Breakpoint.Compact;
    } else if (isMedium) {
        return Breakpoint.Medium;
    } else {
        return Breakpoint.Expanded;
    }
}
